<!-- 表1填写 -->

<template>
	<div class="tabCage ssTab3">
		 <div class="tabTtl">
		 	 <span>经营情况信息</span>
		 </div>

		 <el-form ref="paramCk" :model="params" :rules="rules">
			 <div class="headBar">
			 	 <span>{{ yearSet.year1 }}年</span>
			 </div>
			 <div class="editArea">
			 	  <table>
			 	  	  <tr>
			 	  	  	  <td class="edName">出版单位年销售收入（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="firstTotalSales" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.firstTotalSales" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  	  <tr>
			 	  	  	  <td class="edName">出版单位年利润总额（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="firstTotalProfit" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.firstTotalProfit" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  	  <tr>
			 	  	  	  <td class="edName">连续型电子出版物年销售收入（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="firstSales" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.firstSales" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  	  <tr>
			 	  	  	  <td class="edName">连续型电子出版物年利润总额（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="firstProfit" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.firstProfit" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  </table>

			 </div>
             <div class="headBar">
			 	 <span>{{ yearSet.year2 }}年</span>
			 </div>
			 <div class="editArea">
			 	  <table>
			 	  	  <tr>
			 	  	  	  <td class="edName">出版单位年销售收入（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="secondTotalSales" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.secondTotalSales" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  	  <tr>
			 	  	  	  <td class="edName">出版单位年利润总额（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="secondTotalProfit" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.secondTotalProfit" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  	  <tr>
			 	  	  	  <td class="edName">连续型电子出版物年销售收入（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="secondSales" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.secondSales" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  	  <tr>
			 	  	  	  <td class="edName">连续型电子出版物年利润总额（万元）：</td>
			 	  	  	  <td class="edInp">
			 	  	  	      <el-form-item prop="secondProfit" :inline-message="true">
			 	  	  	  	      <el-input-number controls-position="right" :min="0" :precision="2" v-model="params.secondProfit" disabled size="small"></el-input-number>
			 	  	  	  	  </el-form-item>
			 	  	  	  </td>
			 	  	  </tr>
			 	  </table>

			 </div>
		 </el-form>

		 <div class="subArea">
              <el-button @click="goBack" size="small">返回</el-button>
		 </div>

	</div>
</template>

<script>
	import { bsParams,paramsRule } from '@/components/LongParams/paramsSEt3';
	import { ssSave3,ssRead3 } from '@/api/pressRole/pressSuccessive';
    export default{
    	 data(){
    	 	 return{
                 params:bsParams,
                 rules:paramsRule,
                 submiting:false,

                 yearSet:{
                    year1:'',
                    year2:''
                 }
    	 	 }
    	 },
    	 watch:{
    	 	 'params.areaDate':function(dat){
                 this.params.startYyDate = dat[0];
                 this.params.endYyDate = dat[1];
    	 	 }
    	 },
    	 methods:{
    	 	 editSave:function(name){

                 this.$refs[name].validate((valid) => {
                 	if(valid){
                 		 this.params.publishId = this.$route.query.pressId;
                 		 this.params.publishMaterialId = this.$route.query.mtId;

                         this.params.firstYear = this.yearSet.year1;
                         this.params.secondYear = this.yearSet.year2;

                         ssSave3({plxdzfinance:this.params}).then(response => {
                              this.submiting = false;
				              this.$message({
				                message: '保存成功！',
				                type: 'success'
				              });
				              for(let key in this.params){
				              	 this.params[key] = '';
				              };
				              this.goBack();
                         }).catch(error => {
                         	  this.submiting = false;
                         })
                 	}else{
                 		return false;
                 	}
                 })
    	 	 },

            tabReEdit:function(){
                ssRead3({publishMaterialId:this.$route.query.mtId}).then(response => {
                	 this.params = response.plxdzFinance;
                })
            },

            fileTdSet:function(id){
            	this.params.yyzzId = id;
            },

            layChange:function(){
            	 if(this.isNot[this.params.isIndependentLP] == "是"){
                    this.layDasion = 1;
            	 }else{
            	 	this.layDasion = 2;
            	 }
            },

    	 	goBack:function(){
					    this.$router.go(-1);
    	 		 // this.$router.push({
    	 	 	 // 	 path:'successive_skim',
    	 	 	 // 	 query:{
    	 	 	 // 	 	 mtId:this.$route.query.mtId,
    	 	 	 // 	 	 pressId:this.$route.query.pressId,
    	 	 	 // 	 	 listId:this.$route.query.listId,
    	 	 	 // 	 	 bookName:this.$route.query.bookName
    	 	 	 // 	 }
    	 	 	 // });
    	 	}
    	 },
    	 created:function(){
    	 	 if(this.$route.query.pgress == 2){
                 this.tabReEdit();
    	 	 }

    	 	 let newDate = new Date();
             this.yearSet.year1 = newDate.getFullYear() - 2;
             this.yearSet.year2 = newDate.getFullYear() - 1;
    	 }
    }

</script>

<style lang="scss">
    @import "src/styles/pressRoleE";

    .ssTab3{
    	margin-top: 0px;

    	.edInp .el-input-number{
	        width: 300px;
	    }

	    .el-textarea{
	    	width: 450px;
	    }

	    .edName{
	    	width:300px !important;
	    }
    }

    .el-date-editor{
    	border-radius: 0px;
    }


</style>



// WEBPACK FOOTER //
// ssTab3 copy.vue?34b087b3